import { render } from "./ClientesComponent.vue?vue&type=template&id=719de3ac&scoped=true"
import script from "./ClientesComponent.vue?vue&type=script&lang=js"
export * from "./ClientesComponent.vue?vue&type=script&lang=js"

import "./ClientesComponent.vue?vue&type=style&index=0&id=719de3ac&scoped=true&lang=css"

import exportComponent from "/Users/norberto/Documents/Marketing HL/adminmkthl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719de3ac"]])

export default __exports__